import {announce as $a46cf152bb926da5$export$a9b970dcc4ae71a9, clearAnnouncer as $a46cf152bb926da5$export$d10ae4f68404609a, destroyAnnouncer as $a46cf152bb926da5$export$d8686216b8b81b2f} from "../../../private/live-announcer/LiveAnnouncer.mjs";




export {$a46cf152bb926da5$export$a9b970dcc4ae71a9 as announce, $a46cf152bb926da5$export$d10ae4f68404609a as clearAnnouncer, $a46cf152bb926da5$export$d8686216b8b81b2f as destroyAnnouncer};
//# sourceMappingURL=LiveAnnouncer.mjs.map
